module.exports = __webpack_public_path__ + "img/main.97bf885a.png";